import moment from "moment";
import Vue from "vue";

const getDefaultRange = () => {
  return {
    startDate: moment().subtract(90, 'days').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD')
  }
};

const state = {
  dates: {
    points: getDefaultRange(),
    messages: getDefaultRange()
  },
}

const actions = {
  setPointsDates({commit}, dates) {
    commit('SET_POINTS_DATES', dates)
  },
  setMessagesDates({commit}, dates) {
    commit('SET_MESSAGES_DATES', dates)
  },
  resetDates({commit}, key) {
    commit('RESET_DATES', key);
  }
};

const mutations = {
  SET_POINTS_DATES(state, dates) {
    Vue.set(state.dates, 'points', dates)
  },
  SET_MESSAGES_DATES(state, dates) {
    Vue.set(state.dates, 'messages', dates)
  },
  RESET_DATES(state, key) {
    Vue.set(state.dates, key, getDefaultRange());
  }
};

export default {
  state,
  actions,
  mutations,
}
